import { render, staticRenderFns } from "./dialogs.vue?vue&type=template&id=dd09f060&scoped=true&lang=pug"
import script from "./dialogs.vue?vue&type=script&lang=js"
export * from "./dialogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd09f060",
  null
  
)

export default component.exports